module.exports = __webpack_public_path__ + "static/domobile2-416f4bede07c0b7100193392bf92234f.png";